import { render, staticRenderFns } from "./IconsSelect.vue?vue&type=template&id=67b9b680"
import script from "./IconsSelect.vue?vue&type=script&lang=js"
export * from "./IconsSelect.vue?vue&type=script&lang=js"
import style0 from "./IconsSelect.vue?vue&type=style&index=0&id=67b9b680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports